// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-1a04ab67f281803bae802e24575c8a4e","button__box":"button__box-dbf6eec8ce28c0a6f88fb93a6be69a50"};